import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ShareReport from "./component";
import { saveUserSocialButtonClick } from "../../pages/dashboard-b/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveUserSocialButtonClickConnect: saveUserSocialButtonClick,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ShareReport);
